<div class="div-action-top">
  <div class="left">
    <div class="form-filter ant-form ant-form-inline">
      <input style="width: 200px;" [(ngModel)]="searchText" (ngModelChange)="doSearch()" nz-input
             placeholder="Tìm mã phiếu"/>
    </div>
  </div>
</div>
<div class="data-table">
  <nz-table #basicTable [nzData]="filterData" (nzCurrentPageDataChange)="currentPageDataChange($event)"
            [nzPageSizeOptions]="pageSize" [nzPageSize]="defaultPage" nzSize="small" nzShowSizeChanger
            [nzShowTotal]="rangeTemplate" [nzLoading]="loading" (nzQueryParams)="onQueryParamsChange($event)">
    <thead>
    <tr>
      <th nzLeft class="text-nowrap" width="50px">#</th>
      <th nzLeft class="text-nowrap" width="150px">Mã phiếu</th>
      <th nzLeft class="text-nowrap" width="150px">Mô tả phiếu</th>
      <th class="text-nowrap" width="150px">Đối tượng nhập</th>
      <th class="text-nowrap" width="150px" nzFormat="dd/MM/yyyy HH:mm">Thời gian nhập</th>
      <th class="text-nowrap" width="150px">Người nhập</th>
      <th class="text-nowrap" width="100px">Action</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of basicTable.data;let i = index;">
      <td nzLeft class="text-nowrap">{{getRowIndex(i, basicTable.nzPageIndex, basicTable.nzPageSize)}}</td>
      <td nzLeft class="text-nowrap">{{ data.code }}</td>
      <td nzLeft class="">{{ data.description }}</td>
      <td class="">{{ data.fromWareHouse?.name }}</td>
      <td class="text-nowrap">{{ data.fromWareHouse?.createDate | date:'dd/MM/yyyy HH:mm' }}</td>
      <td class="text-nowrap">{{ data.importerName }}</td>
      <td class="text-nowrap">
        <button nz-button nzType="primary" nzSize="small" class="btn-right" (click)="showConfirm(data)"><span class="fa fa-check fa-fw"></span>
        </button>
        <button nz-button nzSize="small" nzType="primary" class="btn-right" (click)="showDetails(data)"><span class="fa fa-info fa-fw"></span>
        </button>
      </td>
    </tr>
    </tbody>
  </nz-table>
  <ng-template #rangeTemplate let-range="range" let-total>
    {{ range[0] }}-{{ range[1] }} {{'of' | translate }} {{ total }} {{'items' | translate }}
  </ng-template>
</div>

<nz-modal nzWidth="1200px" [(nzVisible)]="isVisibleAdd" nzClosable="false" [nzTitle]="title1" nzMaskClosable="false">
  <ng-template #title1>
    Thông tin phiếu xác nhận
    <div class="pull-right icon-close">
      <em (click)="handleCancel()" nz-icon nzType="close" nzTheme="outline"></em>
    </div>
  </ng-template>
  <div>
    <div class="input-wrap nz-row row-width">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Mã phiếu</label>
      <nz-form-control [nzSpan]="16" style="position: relative;">
        <input [disabled]="viewOnly" [(ngModel)]="selectedData.code" nz-input placeholder="Mã sẽ tự thêm nếu ô bỏ trống .."/>
      </nz-form-control>
    </div>
    <div class="input-wrap nz-row row-width">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Mô tả phiếu<em
        class="fa fa-asterisk required"></em></label>
      <div nz-col [nzSpan]="16">
        <input [disabled]="viewOnly" nz-input placeholder="Mô tả phiếu" [(ngModel)]="selectedData.description"/>
      </div>
    </div>
    <div class="input-wrap nz-row row-width" *ngIf="selectedWarehouse && selectedWarehouse.inverseParent.length">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Kho nhận<em
        class="fa fa-asterisk required"></em></label>
      <div nz-col [nzSpan]="16">
        <nz-select [disabled]="viewOnly" nzShowSearch nzAllowClear nzPlaceHolder="Chọn kho nhận" [(ngModel)]="selectedData.toWareHouseId" style="width: 100%">
          <nz-option *ngFor="let item of selectedWarehouse.inverseParent" [nzLabel]="item.name" [nzValue]="item.id"></nz-option>
        </nz-select>
      </div>
    </div>
    <div class="input-wrap nz-row row-width">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Người nhận<em
        class="fa fa-asterisk required"></em></label>
      <nz-form-control [nzSpan]="16" style="position: relative;">
        <input [disabled]="viewOnly" id="name1" nz-input placeholder="Nhập tên người nhận .." [(ngModel)]="selectedData.receiverName"/>
      </nz-form-control>
    </div>
    <div class="input-wrap nz-row row-width">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Người nhập<em
        class="fa fa-asterisk required"></em></label>
      <nz-form-control [nzSpan]="16" style="position: relative;">
        <input [disabled]="viewOnly" id="name2" nz-input placeholder="Nhập tên người nhập .." [(ngModel)]="selectedData.importerName"/>
      </nz-form-control>
    </div>
    <div class="input-wrap nz-row row-width" *ngIf="selectedWarehouse && !selectedWarehouse.inverseParent.length">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Loại đối tượng nhận<em
        class="fa fa-asterisk required"></em></label>
      <div nz-col [nzSpan]="16">
        <nz-select [disabled]="viewOnly" nzShowSearch nzAllowClear nzPlaceHolder="Chọn máy xét nghiệm" [(ngModel)]="selectedData.receiveType" style="width: 100%">
          <nz-option nzLabel="Máy xét nghiệm" [nzValue]="1"></nz-option>
          <nz-option nzLabel="Khác" [nzValue]="2"></nz-option>
        </nz-select>
      </div>
    </div>
    <div class="input-wrap nz-row row-width" *ngIf="selectedWarehouse && !selectedWarehouse.inverseParent.length">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Đối tượng nhận<em
        class="fa fa-asterisk required"></em></label>
      <div nz-col [nzSpan]="16">
        <nz-select [disabled]="viewOnly" *ngIf="selectedData.receiveType === 1" nzShowSearch nzAllowClear nzPlaceHolder="Chọn đối tượng nhận" [(ngModel)]="selectedData.recipient" style="width: 100%">
          <nz-option *ngFor="let m of machines" [nzLabel]="m.name" [nzValue]="m.name"></nz-option>
        </nz-select>
        <input [disabled]="viewOnly" nz-input *ngIf="selectedData.receiveType === 2" placeholder="Tên đối tượng" [(ngModel)]="selectedData.recipient"/>
      </div>
    </div>
    <div class="input-wrap nz-row row-width">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Scan barcode</label>
      <div nz-col [nzSpan]="16">
        <nz-switch [disabled]="viewOnly" nzSize="default" [(ngModel)]="selectedData.scanBarcode"></nz-switch>
      </div>
    </div>
  </div>
  <!-- Thông tin chi tiết phiếu xuất -->
  <button *ngIf="viewOnly" nz-button nzSize="small" nzType="primary" class="btn-add-asset btn-right" type="button"
          (click)="exportPDF()">
    <em class="fas fa-file-pdf fa-fw"></em>
    Xem trước
  </button>
  <nz-table [nzData]="datas" [nzShowPagination]="false"  #spreadsheet  [nzScroll]="{ y: '250px' }" id="detailTable">
    <thead>
    <tr>
      <th nzWidth="80px">STT</th>
      <th nzWidth="120px">Barcode<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="180px">Mã - Tên hóa chất<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Code NSX<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Hãng/Nước SX<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Số lô<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Hạn sử dụng<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Seri<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Quy cách đóng gói<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="100px">Đơn vị<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="120px">Số lượng<em class="fa fa-asterisk required"></em></th>
      <!-- <th nzWidth="80px"></th> -->
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of selectedData.warehouseExportDetails; let i = index">
      <td>
        {{ i + 1 }}
      </td>
      <td>
        {{item.parcelDetailCode}}
      </td>
      <td>
        {{item.chemical.name}}
      </td>
      <td>
        {{item.manufacturerCode}}
      </td>
      <td>
        {{item.madeIn}}
      </td>
      <td>
        {{item.batchNumber}}
      </td>
      <td>
        {{item.expiredDate | date: 'dd-MM-yyyy'}}
      </td>
      <td>
        {{item.serialNumber}}
      </td>
      <td>
        {{ item.chemical?.packingQuantity }} {{ item.unitTypeText }}/{{ item.chemical?.packing }}
      </td>
      <td>
        {{item.unitTypeText}}
      </td>
      <td>
        {{item.amount}}
      </td>
      <!-- <td>
        <button *ngIf="!viewOnly" nzSize="small" nz-button nzType="danger" class="button-update btn-right" (click)="deleteDetail(item)">Xóa
        </button>
      </td> -->
    </tr>
    </tbody>
  </nz-table>

  <div *nzModalFooter>
    <button nz-button (click)="handleCancel()">{{'cancel' | translate }}</button>
    <!-- <button [nzLoading]="loadingButton" nz-button *ngIf="!viewOnly" nzType="primary" (click)="handleOk()" class="button-submit">{{'save' | translate }}</button> -->
  </div>
</nz-modal>
